module.exports = __webpack_public_path__ + "static/media/oneMinute-intro.fe7a37db.mp3";